/* eslint-disable react/jsx-props-no-spreading */
import { cloneElement, isValidElement } from 'react';
import { Collapse } from 'react-bootstrap';
import type { FunctionComponent } from 'react';

import type { AccordionBodyProps } from './useAccordion';

type Props = AccordionBodyProps & {
  isOpen: boolean;
};

export type AccordionBodyContentProps = {
  // This is optional because it will be provided by the Accordion Body component, but we don't
  // want to make it required as a prop on the child component(s).
  isOpen?: boolean;
};

/**
 * The body of the accordion component. Holds any arbitrary content.
 */
const Body: FunctionComponent<Props> = ({ children, isOpen, ...props }) => (
  <Collapse in={isOpen}>
    <div {...props}>
      {children && isValidElement<{ isOpen?: boolean }>(children)
        ? cloneElement(children, { isOpen })
        : children}
    </div>
  </Collapse>
);

Body.displayName = 'AccordionBody';

export default Body;
